import { html } from 'lit';
const Notification =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9.255 4.832a2.75 2.75 0 0 1 5.49 0A6.75 6.75 0 0 1 18.75 11v3.159c0 .34.135.665.375.906l1.064 1.063c.598.599.175 1.622-.672 1.622H15.75V18a3.75 3.75 0 0 1-7.5 0v-.25H4.483c-.846 0-1.27-1.023-.672-1.622l1.064-1.063c.24-.24.375-.567.375-.906V11a6.75 6.75 0 0 1 4.005-6.168M9.75 17.75V18a2.25 2.25 0 0 0 4.5 0v-.25zm2.25-14c-.69 0-1.25.56-1.25 1.25v.341a.75.75 0 0 1-.5.708A5.25 5.25 0 0 0 6.75 11v3.159c0 .737-.293 1.445-.815 1.966l-.124.125h12.378l-.124-.125a2.78 2.78 0 0 1-.815-1.966V11c0-2.285-1.46-4.23-3.5-4.951a.75.75 0 0 1-.5-.708V5c0-.69-.56-1.25-1.25-1.25" clip-rule="evenodd"/>
  </svg>
`;
export default Notification;
